
import HeroSection from '@/components/HeroSection';
import ResearchPreview from '@/components/ResearchPreview';
import PerformancePreview from '@/components/PerformancePreview';
import PartnersPreview from '@/components/PartnersPreview';
import RequestButton from '@/components/RequestButton';
import PageLayout from '@/components/PageLayout';
import { useIsMobile } from '@/hooks/use-mobile';

const Index = () => {
  const isMobile = useIsMobile();

  return (
    <PageLayout>
      <main>
        <HeroSection />
        <PerformancePreview />
        <PartnersPreview />
        <ResearchPreview />
        
        {/* Contact CTA Section */}
        <section className="py-16 sm:py-20 relative overflow-hidden">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-2xl xs:text-3xl md:text-4xl font-bold mb-4 sm:mb-6">Interested in Learning More?</h2>
              <p className="text-delphi-light/70 text-base sm:text-lg mb-6 sm:mb-10 max-w-2xl mx-auto">
                Contact our team to discuss investment opportunities or potential research collaborations.
              </p>
              
              <RequestButton 
                label="Get in Touch"
                requestType="Homepage CTA Button"
                className="px-6 py-3 bg-delphi-red text-white rounded-md font-medium"
              />
            </div>
          </div>
        </section>
      </main>
    </PageLayout>
  );
};

export default Index;
